import React from 'react';
import { usePathParam } from 'react-resource-router';
import { PageError } from 'components/errors/PageError';
import { css } from '@compiled/react';
import { DangerTriangle, NotFound } from 'assets/images';

const ERRORS: {
  [index: string]: JSX.Element;
} = {
  generic_error: (
    <PageError
      image={DangerTriangle}
      heading="Something went wrong"
      description="We're working to fix the problem. Try again later, or visit our homepage."
      link="/user"
      linkText="Go home"
    />
  ),
  user_not_found: (
    <PageError
      image={NotFound}
      heading="We couldn't find this profile"
      description="It may have been deleted, or there might be a typo in the URL. Check the link, or visit our homepage."
      link="/user"
      linkText="Go home"
    />
  ),
  initialization_failed: (
    <PageError
      image={NotFound}
      heading="We couldn't initialize user"
      description="User could not be initialized due to an unknown error"
      link="/user"
      linkText="Go home"
    />
  ),
  not_authorized: (
    <PageError
      image={DangerTriangle}
      heading="Not Authorized"
      description="User is not authorized to visit this page"
      link="/user"
      linkText="Go home"
    />
  ),
  invalid_path: (
    <PageError
      image={NotFound}
      heading="Invalid Path"
      description="This path does not exist"
      link="/user"
      linkText="Go home"
    />
  ),
  consent_failed: (
    <PageError
      image={NotFound}
      heading="Consent Failed"
      description="Something went wrong. Please try again later or contact support."
      link="/user"
      linkText="Go home"
    />
  ),
};

const ErrorPage: React.FC = () => {
  const [errorId] = usePathParam('errorId');
  const errorComponent =
    !errorId || !ERRORS[errorId] ? ERRORS.generic_error : ERRORS[errorId];

  return <div css={errorContainerStyles}>{errorComponent}</div>;
};

const errorContainerStyles = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

export default ErrorPage;
